<div class="card mb-0 main-card overflow-auto">
  <div class="card-header">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="card-title align-items-center d-flex p-0">
        Attornies
        <span class="badge text-dark bg-body-secondary ms-2">{{ TotalAttorney }}</span>
      </h5>
      <div class="d-flex">
        <div class="search-bar">
          <div class="form-group">
            <div class="input-group has-prefix">
              <i class="prefix bi bi-search"></i>
              <input type="text" class="form-control" name="query" placeholder="Search Attorney" title="Search Attorney" (keyup)="SearchData()" [(ngModel)]="SearchVal" />
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#AddAttorney" (click)="OpenAddPopup()"><i class="bi bi-plus"></i> Add Attorney</button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="table-responsive h-100">
      <table class="table table-hover table-x-padding mb-0" *ngIf="TotalAttorney || IsLoading">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">
              <button
                class="btn btn-sm p-0 btn-sort"
                (click)="SortData('attorneyName')"
                [ngClass]="this.PaginationParams.sortColumn === 'attorneyName' ? this.PaginationParams.sortOrder : ''"
                [disabled]="IsLoading"
              >
                Attorney Name
                <i class="text-body-tertiary bi-arrow-down-short"></i>
              </button>
            </th>
            <th scope="col">Address</th>
            <th scope="col">Town</th>
            <th scope="col">Zip</th>
            <th scope="col">Phone</th>
            <th scope="col">Fax</th>
            <th scope="col">Contact</th>
            <th scope="col" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!IsLoading">
            <tr *ngFor="let attorney of AttorneyList; index as i">
              <th scope="row">{{ i + 1 + PaginationParams.skip }}</th>
              <td>{{ attorney.attorneyName }}</td>
              <td>{{ attorney.address }}</td>
              <td>{{ attorney.town }}</td>
              <td>{{ attorney.zip }}</td>
              <td>{{ attorney.phone | phonenumber : 'format' }}</td>
              <td>{{ attorney.fax | phonenumber : 'format' }}</td>
              <td>{{ attorney.contact | phonenumber : 'format' }}</td>
              <td class="text-end">
                <button type="button" class="btn btn-sm" data-bs-toggle="modal" data-bs-target="#AddAttorney" *ngIf="attorney.id" (click)="OpenEditPopup(attorney.id)">
                  <i class="bi bi-pencil-square fs-5"></i>
                </button>
              </td>
            </tr>
          </ng-container>

          <ng-container *ngIf="IsLoading">
            <tr *ngFor="let employee of ['', '', '', '', '']; index as i">
              <td *ngFor="let employee of ['', '', '', '', '', '', '', '', '']; index as i">
                <p class="placeholder-glow">
                  <span class="placeholder col-12"></span>
                </p>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div class="empty-data-placeholder" *ngIf="!TotalAttorney && !IsLoading">
        <div class="text-center">
          <h3 class="text-body-tertiary"><i class="bi bi-exclamation-triangle"></i> Oops..!</h3>
          <p>No Attornies Found</p>
        </div>
      </div>
    </div>
  </div>

  <div class="card-footer" *ngIf="TotalAttorney">
    <app-pagination [totalItems]="TotalAttorney" [pageSize]="PaginationParams.take" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" />
  </div>
</div>

<!-- Add Attorney -->
<div class="modal fade" id="AddAttorney" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ IsEditAttorney ? 'Edit' : 'Add' }} Attorney</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="AttorneyForm.reset()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="AttorneyForm">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <label for="attorneyName">Attorney Name</label>
                <div
                  class="input-group"
                  [ngClass]="{
                    'has-invalid': AttorneyForm.get('attorneyName')?.invalid && AttorneyForm.get('attorneyName')?.touched
                  }"
                >
                  <input type="text" class="form-control" id="attorneyName" formControlName="attorneyName" />
                  <span class="error-message" *ngIf="AttorneyForm.get('attorneyName')?.invalid && AttorneyForm.get('attorneyName')?.touched"> Attorney Name is required </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="address">Address</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="address" formControlName="address" />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="town">Town</label>
                <div
                  class="input-group"
                  [ngClass]="{
                    'has-invalid': AttorneyForm.get('town')?.invalid && AttorneyForm.get('town')?.touched
                  }"
                >
                  <input type="text" class="form-control" id="town" formControlName="town" />
                  <span class="error-message" *ngIf="AttorneyForm.get('town')?.invalid && AttorneyForm.get('town')?.touched"> Town is required </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="zip">ZIP Code</label>
                <div
                  class="input-group"
                  [ngClass]="{
                    'has-invalid': AttorneyForm.get('zip')?.invalid && AttorneyForm.get('zip')?.touched
                  }"
                >
                  <input type="text" class="form-control" id="zip" [maxlength]="MaxZipLength" (keydown)="sharedService.validateNumber($event)" formControlName="zip" />
                  <span class="error-message" *ngIf="AttorneyForm.get('zip')?.invalid && AttorneyForm.get('zip')?.touched"> Enter a valid 5-digit ZIP code </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="phone">Phone</label>
                <div
                  class="input-group"
                  [ngClass]="{
                    'has-invalid': AttorneyForm.get('phone')?.invalid && AttorneyForm.get('phone')?.touched
                  }"
                >
                  <input
                    type="text"
                    (keydown)="sharedService.validateNumber($event)"
                    [value]="AttorneyForm.get('phone')?.value | phonenumber : 'format'"
                    [maxlength]="MaxPhoneLength"
                    class="form-control"
                    id="phone"
                    formControlName="phone"
                  />
                  <span class="error-message" *ngIf="AttorneyForm.get('phone')?.invalid && AttorneyForm.get('phone')?.touched"> Enter a valid 10-digit phone number </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="fax">Fax</label>
                <div
                  class="input-group"
                  [ngClass]="{
                    'has-invalid': AttorneyForm.get('fax')?.invalid && AttorneyForm.get('fax')?.touched
                  }"
                >
                  <input
                    [value]="AttorneyForm.get('fax')?.value | phonenumber : 'format'"
                    type="text"
                    class="form-control"
                    id="fax"
                    [maxlength]="MaxPhoneLength"
                    (keydown)="sharedService.validateNumber($event)"
                    formControlName="fax"
                  />
                  <span class="error-message" *ngIf="AttorneyForm.get('fax')?.invalid && AttorneyForm.get('fax')?.touched"> Enter a valid 10-digit fax number (optional) </span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="contact">Secondary Contact</label>
                <div class="input-group">
                  <input [value]="AttorneyForm.get('contact')?.value" type="text" class="form-control" id="contact" formControlName="contact" />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-between align-items-center">
        <div class="d-flex">
          <ng-container *ngIf="IsEditAttorney">
            <button (click)="DeleteAttorney()" data-bs-dismiss="modal" type="button" class="btn btn-danger">Delete Attorney</button>
          </ng-container>
        </div>
        <div class="d-flex">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button data-bs-dismiss="modal" type="button" [disabled]="!AttorneyForm.valid || IsLoading" class="btn btn-primary ms-2" (click)="IsEditAttorney ? UpdateAttorney() : AddAttorney()">
            {{ IsEditAttorney ? 'Update' : 'Save Attorney' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
